import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './SurveyTakerPageContainer.scss';

const SurveyTakerPageContainer = ({
  className,
  isFullWidth,
  children,
  e2e,
  style,
}) => (
  <div
    style={style}
    className={cx(
      styles.container,
      {
        [styles.fullWidthContainer]: isFullWidth,
      },
      className,
    )}
    data-e2e={e2e}
  >
    {children}
  </div>
);

SurveyTakerPageContainer.propTypes = {
  e2e: PropTypes.string,
  isFullWidth: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  style: PropTypes.object,
};

export default SurveyTakerPageContainer;
